import React, { useCallback, useState } from 'react';
import ArrowBack from '@mui/icons-material/ArrowBack';
import Close from '@mui/icons-material/Close';
import { Box, Modal } from '@mui/material';
import { useAppSelector } from 'src/redux/hooks';
import { getExperiments, getIsMobileApp } from 'src/redux/selectors';
import {
  isNerdyTipAndProgressBarActive,
  isProgressBarOnlyActive,
} from 'src/lib/experiments';

import NerdWalletLogo from 'src/components/nerdwallet-logo';
import ExitModalContent from '../exit-modal/exit-modal-content';
import { theme } from '../providers/theme';

const buttonStyles = {
  position: 'absolute',
  background: 'transparent',
  padding: 0,
  border: 0,
  color: 'neutral.main',
  cursor: 'pointer',
};

type NavbarHeaderProps = {
  showBack?: boolean;
  showClose?: boolean;
  onBack?: () => void;
  onCancel?: () => void;
};
const NavbarHeader: React.FC<NavbarHeaderProps> = ({
  showBack = true,
  showClose = true,
  onBack,
  onCancel,
}) => {
  const experiments = useAppSelector(getExperiments);
  const [open, setOpen] = useState(false);
  const handleOpen = useCallback(() => setOpen(true), []);
  const handleClose = useCallback(() => setOpen(false), []);
  const isMobileApp = useAppSelector(getIsMobileApp);

  return (
    <Box
      sx={(theme) => ({
        position: 'relative',
        minHeight: '1rem',
        [theme.breakpoints.up('sm')]: {
          marginTop:
            isNerdyTipAndProgressBarActive(experiments) ||
            isProgressBarOnlyActive(experiments)
              ? 0
              : 5,
        },
      })}
    >
      {showBack && (
        <Box
          component="button"
          type="button"
          aria-label="Back"
          sx={{
            ...buttonStyles,
            left: 0,
            zIndex: 1,
            [theme.breakpoints.down('sm')]: {
              left: 16,
            },
          }}
          onClick={onBack}
        >
          <ArrowBack sx={{ fontSize: '24px' }} />
        </Box>
      )}
      <Box
        sx={(theme) => ({
          bgcolor: theme.palette.common.white,
          position: 'absolute',
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
          [theme.breakpoints.up('sm')]: {
            display: 'none',
          },
        })}
      >
        <Box
          component="a"
          href="/?trk=nw_gn_5.0"
          sx={{
            marginX: 'auto',
            '& svg': {
              width: '7.375rem',
            },
          }}
        >
          <NerdWalletLogo />
        </Box>
      </Box>
      {showClose && !isMobileApp && (
        <Box
          component="button"
          type="button"
          aria-label="Close"
          sx={{
            ...buttonStyles,
            right: 0,
            [theme.breakpoints.down('sm')]: {
              right: 16,
            },
          }}
          onClick={handleOpen}
        >
          <Close sx={{ fontSize: '24px' }} />
        </Box>
      )}
      <Modal
        open={open}
        onClose={handleClose}
        sx={{ display: 'flex', flexDirection: 'column' }}
      >
        <ExitModalContent handleClose={handleClose} onCancel={onCancel} />
      </Modal>
    </Box>
  );
};

export default NavbarHeader;
